import React, { HTMLAttributes, ReactNode } from 'react'

import { cn } from '@frame/lib/utils/cn'
import { PrimitiveDataAttribute } from '@frame/types'

type Props = {
  as?: 'h5' | 'div'
  children: ReactNode
  className?: HTMLAttributes<HTMLHeadingElement>['className']
}

export function H5({ children, className, as: Component = 'h5' }: Props) {
  return (
    <Component
      data-cy={PrimitiveDataAttribute.TW_PRIMITIVE_H5}
      className={cn('text-sm font-medium text-moss-950', className)}
    >
      {children}
    </Component>
  )
}
